module.exports = __webpack_public_path__ + "static/assets/c133e3463fb1e67596c781605680adf0.svg";